"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.Header = styled_components_1.default.div `
  font-size: 12px;
  color: #6b778c;
  font-weight: 600;
  line-height: 1.33333333;
`;
exports.Header.displayName = "Header";
